import { endpoints } from './endpoints';

export const downloadUrls = {
    cfdiXml(uuid: string): string {
        return endpoints.cfdi.downloadXml(uuid);
    },
    cfdiPdf(uuid: string): string {
        return endpoints.cfdi.downloadPdf(uuid);
    },
    paymentXml(uuid: string): string {
        return endpoints.cfdi.downloadPaymentXml(uuid);
    },
    paymentPdf(uuid: string): string {
        return endpoints.cfdi.downloadPaymentPdf(uuid);
    },
};
